/*
    Imports the Roast API URL from the config.
*/

import apiCtrl from '@/services/api/abstract/abstract-api.js';
export default {
  threadPostMessageUrl: function(id) {
    return apiCtrl.getBaseUrl() + '/thread/' + id + '/message';
  },

  getThreadSearchPaginate: function(params, config = {}) {
    let searchParams = {};
    const defaultParams = {
      search: {},
      page: null,
      searchField: null,
      filter: null,
      operator: 'OR',
      orderBy: null,
      sortedBy: null,
      searchJoin: 'or',
    };

    for (const param in params) {
      if (params.hasOwnProperty(param)) {
        const value = params[param];
        if (value) {
          searchParams[param] = value;
        }
      }
    }

    searchParams = Object.assign({}, defaultParams, searchParams);
    // Listado ligero: cada conversación trae el último mensaje, no el hilo entero
    return apiCtrl.get('/thread/list', Object.assign({ params: searchParams }, config));
  },

  /*
        GET     /api/v1/threads
    */
  getThreads: function() {
    return apiCtrl.get('/thread/all');
  },
  /*
        GET     /api/v1/threads
    */
  getActiveThreads: function() {
    let config = {};
    config.params = {
      search: 'active',
      searchField: 'status',
    };
    return apiCtrl.get('/thread/all', config);
  },

  /*
        GET     /api/v1/threads
    */
  getClosedThreads: function() {
    let config = {};
    config.params = {
      search: 'closed',
      searchField: 'status',
    };
    return apiCtrl.get('/thread');
  },

  /*
        GET     /api/v1/threads/{threadID}
    */
  getThread: function(threadID) {
    return apiCtrl.get('/thread/' + threadID);
  },

  /*
        POST    /api/v1/threads
    */
  postThread: function(data) {
    return apiCtrl.post('/thread', data);
  },

  /*
        GET     /api/v1/thread-recipients/my-customers
        Clientes activos del asesor: destinatarios de "Enviar a todos mis clientes"
    */
  getMyCustomerRecipients: function() {
    return apiCtrl.get('/thread-recipients/my-customers');
  },

  postMessage: function(data) {
    return apiCtrl.post('/thread/' + data.thread + '/message', {
      message: data.message,
      attached: data.attached ? data.attached : '',
    });
  },

  deleteThread: function(id) {
    return apiCtrl.delete('/thread/' + id);
  },

  deleteMessage: function(id) {
    return apiCtrl.delete('/message/' + id);
  },

  changeThreadStatus: function(id, status, config = {}) {
    return apiCtrl.post(
      '/thread-status/' + id,
      {
        status: status,
      },
      config,
    );
  },
  changeThreadRead: function(id, read, config = {}) {
    return apiCtrl.post(
      '/thread-read/' + id,
      {
        read: read,
      },
      config,
    );
  },
  changeThreadToManage: function(id, toManage, config = {}) {
    return apiCtrl.post(
      '/thread-to-manage/' + id,
      {
        to_manage: toManage,
      },
      config,
    );
  },
  changeThreadReadByCustomer: function(id, read, config = {}) {
    return apiCtrl.post(
      '/thread-read-customer/' + id,
      {
        read_by_customer: read,
      },
      config,
    );
  },
  changeThreadCategory: function(id, categoryValue, categoryName, config = {}) {
    return apiCtrl.post(
      '/thread-category/' + id,
      {
        categoryValue: categoryValue,
        categoryName: categoryName,
      },
      config,
    );
  },
};
